import { ActionContext } from 'vuex';

import { ProjectWithRegionsFilterData } from '../../types/projectWithRegions';
import { PROJECT_WITH_REGIONS_ACTIONS_NAME, PROJECT_WITH_REGIONS_MUTATIONS_NAME } from './name';
import { TProjectWithRegionsState } from './types';

import { TPaginationParams } from '@/types/meta';
import links from '@/utils/links';
import request from '@/utils/request';
4;

import { TBaseFilterPayload } from '@/common/types/filter';
import { getLocalState } from '@/common/utils/store';

export async function searchProjects(
  context: ActionContext<TProjectWithRegionsState, unknown>,
  payload: TBaseFilterPayload<ProjectWithRegionsFilterData & TPaginationParams>,
) {
  return request(
    context,
    {
      url: links.ves.projectWithRegions.searchProjects,
      name: PROJECT_WITH_REGIONS_ACTIONS_NAME.searchProjects,
      abortController: payload.abortController,
    },
    payload.params,
  );
}

export async function getProjectsWithForeignParticipationDatesCount(
  context: ActionContext<TProjectWithRegionsState, unknown>,
  params: ProjectWithRegionsFilterData,
) {
  context.commit(getLocalState(PROJECT_WITH_REGIONS_MUTATIONS_NAME.setIsLoadingCount), true);

  await request(
    context,
    {
      url: links.ves.projectWithRegions.getProjectsWithForeignParticipationDatesCount,
      mutate: getLocalState(PROJECT_WITH_REGIONS_MUTATIONS_NAME.setProjectsWithForeignParticipationDatesCount),
      name: getLocalState(PROJECT_WITH_REGIONS_ACTIONS_NAME.getProjectsWithForeignParticipationDatesCount),
    },
    params,
  );

  context.commit(getLocalState(PROJECT_WITH_REGIONS_MUTATIONS_NAME.setIsLoadingCount), false);
}
